import axios from 'axios';

// In productie serveert Express de build op dezelfde origin → relatieve /api.
// In ontwikkeling de volledige URL naar de backend.
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api');

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  withCredentials: true, // sessiecookie meesturen (SSO)
  headers: { 'Content-Type': 'application/json' },
});
